import { BrandSystemContext } from 'libs/growth-platform-brand-system-v2/src/contexts/BrandSystemContext';
import { LanguagesDropdown } from 'libs/growth-platform-brand-system-v2/src/layouts/LanguagesDropdown';
import { LinkObfuscated } from 'libs/growth-platform-brand-system-v2/src/utils/obfuscation/LinkObfuscated';
import { Link, navigate } from 'gatsby';
import React, { useContext } from 'react';
import { linkResolver } from '../../utils/linkResolver';
import { getSubpath } from '../Seo';

export const Languages = ({ templateData }: any) => {
  const context = useContext(BrandSystemContext);
  const isHome = context?.slug === 'home';
  const allSlugLocales = templateData?._allSlugLocales;
  const subpath = getSubpath(templateData.__typename);
  const languagesData = Object.entries(context.allLangages).reduce(
    (acc, [key, values]) => {
      const findLocalData = allSlugLocales?.find(
        (x: { locale: string }) => key === x.locale,
      );

      const url = findLocalData
        ? linkResolver(findLocalData, findLocalData?.locale, '', subpath, true)
        : values.url;

      const linkProps = isHome ? { to: url } : { href: url, navigate };

      Object.assign(acc, {
        [key]: {
          label: values.label,
          LinkAs: isHome ? Link : LinkObfuscated,
          linkProps,
        },
      });
      return acc;
    },
    {},
  );

  return <LanguagesDropdown languages={languagesData} alignment="right" />;
};
